import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dollarField', 'percentField'];

  declare dollarFieldTarget: HTMLInputElement;

  declare percentFieldTarget: HTMLInputElement;

  connect() {
    this.dollarFieldTarget.addEventListener('input', () => this.updatePercent());
    this.updatePercent();
  }

  updatePercent() {
    const value = parseFloat(this.dollarFieldTarget.value || '');
    this.percentFieldTarget.value = Math.round(value * 100).toString();
  }
}
